import React, { useState } from "react";
import { withRouter } from "react-router";
import classnames from "classnames";
import { connect } from "react-redux";

import "./index.css";

import CardComponent from "./CardComponent";

import Modals from "../../../../components/uiElements/popupModal/modal";

import ACHBankDebit from "./ACHBankDebit";
import SpinnerBorder from "../../../../components/uiElements/loadingSpinner/SpinnerBorder";
import {
  BANK_IMAGE,
  CARD_IMAGE,
  POWERED_BY_STRIPE,
} from "../../../../constants";

const PaymentModal = ({
  accountDetails,
  isOpen,
  setIsOpen,
  onPayment,
  price,
  allowBankDebit,
  title,
}) => {
  const [selectedPayment, setSelectedPayment] = useState("card");

  return (
    <>
      <Modals
        isOpen={isOpen}
        closeModal={() => setIsOpen(true)}
        onBackdropClick={true}
        styles={{
          content: {
            minWidth: "730px",
            maxWidth: "730px",
            minHeight: "600px",
            maxHeight: "600px",
            overflowY: "scroll",
          },
        }}
        title={title}
      >
        <>
          <button
            onClick={() => setIsOpen(false)}
            className="close modalCloseBtn"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>

          <div className="d-flex justify-content-center row my-3 payment-tabs">
            <div
              className={classnames("col-md-5 pr-2 mr-2")}
              style={{
                padding: 5,
                paddingTop: 3,
                paddingBottom: 0,
                borderRadius: 5,
                border:
                  selectedPayment === "card"
                    ? "1px solid #6AA9FF"
                    : "1px solid #8CBCFF",
                cursor: "pointer",
                background: selectedPayment === "card" ? "#8CBCFF" : "#F3F5F7",
                height: 55,
              }}
              onClick={() => setSelectedPayment("card")}
            >
              <img src={CARD_IMAGE} alt="card_image" width={50} />
              <span className="pl-2">Pay using card</span>
            </div>
            {allowBankDebit && (
              <div
                className={classnames("col-md-5")}
                style={{
                  padding: 5,
                  paddingTop: 3,
                  paddingBottom: 0,
                  borderRadius: 5,
                  border:
                    selectedPayment === "bank"
                      ? "1px solid #6AA9FF"
                      : "1px solid #8CBCFF",
                  cursor: "pointer",
                  background:
                    selectedPayment === "bank" ? "#8CBCFF" : "#F3F5F7",
                  height: 55,
                }}
                onClick={() => setSelectedPayment("bank")}
              >
                <img src={BANK_IMAGE} alt="bank_image" width={50} />

                <span className="pl-2">Pay using ACH bank account</span>
              </div>
            )}
          </div>

          <div
            style={{
              maxHeight: 470,
            }}
            className="card-form-component"
          >
            {selectedPayment === "card" ? (
              <CardComponent onPayment={onPayment} price={price} />
            ) : !accountDetails?.getBankAccountLoading ? (
              <ACHBankDebit onPayment={onPayment} price={price} />
            ) : (
              <SpinnerBorder isCenter />
            )}
          </div>
          <div
            className="w-100 position-absolute border-top"
            style={{
              bottom: 60,
              left: 0,
            }}
          ></div>
          <div className="position-absolute stripe-logo">
            <div className="position-relative mx-auto text-center">
              <img
                src={POWERED_BY_STRIPE}
                width={150}
                height={34}
                alt="powered by stripe"
                className="mx-auto"
              />
            </div>
          </div>
        </>
      </Modals>
    </>
  );
};

const mapStoreToProps = ({ onboarding, auth, api, validation }) => ({
  accountDetails: onboarding?.accountDetails,
  form: validation.data,
});

export default withRouter(connect(mapStoreToProps, undefined)(PaymentModal));
